module.exports = __webpack_public_path__ + "img/sx.522d898c.svg";